export default {
  formId: "gene20Form",
  formField: {
    firstName: {
      name: "firstName",
      label: "First name*",
      requiredErrorMsg: "First name is required",
    },
    lastName: {
      name: "lastName",
      label: "Last name*",
      requiredErrorMsg: "Last name is required",
    },
    email: {
      name: "email",
      label: "enter your email",
      requiredErrorMsg: "Email is required",
    },
    password: {
      name: "password",
      label: "enter your password",
      requiredErrorMsg: "Password is required",
    },
    industryCatergory: {
      name: "industryCatergory",
      label: "select your industry",
      requiredErrorMsg: "Name is required",
    },
    experienceLevel: {
      name: "experienceLevel",
      label: "enter level of experience",
      requiredErrorMsg: "Required *",
    },
    profilePic: {
      name: "profilePic",
      label: "upload your profile picture",
    },
    location: {
      name: "location",
      label: "location*",
      requiredErrorMsg: "please enter your business catergory",
    },
    dateOfBirth: {
      name: "dateOfBirth",
      label: "date of birth",
      requiredErrorMsg: "enter your date of birth",
    },
    gender:{
      name: "gender",
      label: "gender",
      requiredErrorMsg: "please fill in your gender",
    },

    phoneContact1: {
      name: "phoneContact1",
      label: "phoneContact1*",
      requiredErrorMsg: "phone number is required",
      invalidErrorMsg: "Enter correct phone number(eg. +27 61 234 5678)",
    },
    phoneContact2: {
      name: "phoneContact2",
      label: "phoneContact2*",
      requiredErrorMsg: "Country is required",
    },
    businessEmail: {
      name: "businessEmail",
      label: "Use this address for payment details",
    },
    whatsappContact: {
      name: "whatsappContact",
      label: "enter your whatsapp contact",
    },
  },
};
